import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { motion } from "framer-motion";
import { X, BookOpen, Loader2 } from "lucide-react";

export default function StoryModeModal({ open, conversationId, conversationName, onClose }) {
  const [scenes, setScenes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !conversationId) return;
    setError("");
    setLoading(true);
    (async () => {
      try {
        const { data } = await api.post(`/ai/story-mode/${conversationId}`);
        setScenes(data.scenes || []);
      } catch (e) {
        setError("Hikaye oluşturulamadı — sohbet çok kısa olabilir.");
      } finally {
        setLoading(false);
      }
    })();
  }, [open, conversationId]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" data-testid="story-mode-modal">
      <div className="bg-white border-hard shadow-hard-lg rounded-2xl w-full max-w-2xl p-6 slide-up max-h-[90vh] overflow-auto">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-display text-2xl flex items-center gap-2"><BookOpen strokeWidth={3} className="w-6 h-6" /> Hikaye Modu</h2>
          <button onClick={onClose} data-testid="story-close-btn" className="w-9 h-9 border-hard-2 rounded-lg flex items-center justify-center press-btn">
            <X strokeWidth={3} className="w-4 h-4" />
          </button>
        </div>
        <p className="text-sm text-[#555] mb-4"><b>{conversationName}</b> sohbetinin mini çizgi romanı</p>

        {loading && (
          <div className="text-center py-10 text-[#555] font-semibold">
            <Loader2 className="w-8 h-8 animate-spin inline-block mb-2" />
            <div>Hikaye örülüyor…</div>
          </div>
        )}

        {error && !loading && <div className="p-4 border-hard-2 rounded-xl bg-[#FF9E80] text-sm font-bold">{error}</div>}

        {!loading && scenes.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {scenes.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.12 }}
                className="border-hard rounded-2xl overflow-hidden shadow-hard-sm"
                data-testid={`story-scene-${i}`}
              >
                <div className="bg-[#D4B3FF] p-4 text-center">
                  <div className="text-5xl">{s.emoji}</div>
                </div>
                <div className="p-3 bg-white">
                  <div className="font-black text-sm">{s.title}</div>
                  <div className="text-xs text-[#333] mt-1">{s.text}</div>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
